// src/components/Footer.js
import React from "react";

export default function Footer() {
  return (
    <footer className="bg-blue-900 text-white p-4 text-center">
      <p>© 2025 Tienda Deportiva. Todos los derechos reservados.</p>
    </footer>
  );
}
